import React from 'react';
import { Gamepad2, Twitter, Instagram, Twitch, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#05050A] border-t border-white/5 pt-16 pb-8" data-id="element-23">
      <div className="container mx-auto px-4" data-id="element-24">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-25">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-26">
            <a href="#" className="flex items-center gap-2 mb-4" data-id="element-27">
              <Gamepad2 className="h-8 w-8 text-fuchsia-500" data-id="element-28" />
              <span className="text-2xl font-bold font-display text-white" data-id="element-29">
                Avatarise
              </span>
            </a>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-30">
              Crafting unique digital identities for gamers worldwide. Level up
              your presence with custom art that speaks your language.
            </p>
            <div className="flex gap-4" data-id="element-31">
              {[Twitter, Instagram, Twitch, Youtube].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-fuchsia-500 hover:text-white transition-all" data-id="element-32">
                  <Icon className="w-5 h-5" data-id="element-33" />
                </a>)}
            </div>
          </div>

          {/* Links */}
          <div data-id="element-34">
            <h4 className="text-white font-bold mb-6 font-display" data-id="element-35">Platform</h4>
            <ul className="space-y-3 text-gray-400" data-id="element-36">
              <li data-id="element-37">
                <a href="#" className="hover:text-fuchsia-400 transition-colors" data-id="element-38">
                  Features
                </a>
              </li>
              <li data-id="element-39">
                <a href="#" className="hover:text-fuchsia-400 transition-colors" data-id="element-40">
                  Gallery
                </a>
              </li>
              <li data-id="element-41">
                <a href="#" className="hover:text-fuchsia-400 transition-colors" data-id="element-42">
                  Pricing
                </a>
              </li>
              <li data-id="element-43">
                <a href="#" className="hover:text-fuchsia-400 transition-colors" data-id="element-44">
                  Testimonials
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-45">
            <h4 className="text-white font-bold mb-6 font-display" data-id="element-46">Contact</h4>
            <ul className="space-y-3 text-gray-400" data-id="element-47">
              <li data-id="element-48">Limassol, Cyprus</li>
              <li data-id="element-49">hello@avatarise.com</li>
              <li data-id="element-50">support@avatarise.com</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-51">
          <p data-id="element-52">© 2026 Avatarise. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-53">
            <a href="#" className="hover:text-gray-300" data-id="element-54">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-300" data-id="element-55">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}